import { JSX, useCallback } from 'react';
import classNames from 'classnames';
import { DirectionalIcon, IconDirection } from '@bg-components/Icon';
import { RippleButton } from '@bg-components/RippleButton';
import { TabsType } from '@bg-components/Tabs/enums/TabsType';
import { CustomCssClassNames } from '@bg-shared';
import { SideScrollDirection } from '../enums/SideScrollDirection';
import classes from './TabsBarArrow.module.scss';

interface IProps {
    direction: SideScrollDirection;
    visible: boolean;
    onClick: (direction: SideScrollDirection) => void;
    type: TabsType;
    ripple?: boolean;
    isRtl?: boolean;
    inLobby?: boolean;
}

export const TabsBarArrow = (props: IProps): JSX.Element => {
    const onClick = useCallback(() => {
        props.onClick(props.direction);
    }, [props.onClick, props.direction]);

    const directions = [IconDirection.LEFT, IconDirection.RIGHT];

    if (props.isRtl) {
        directions.reverse();
    }

    return (
        <RippleButton
            className={classNames(
                classes.tabsBarArrow,
                classes[props.direction],
                classes[props.type],
                {
                    hidden: !props.visible,
                    [classes.lobby]: props.inLobby,
                },
                CustomCssClassNames.TABS_BAR_ARROW,
            )}
            dataQa={`button-tabs-bar-arrow-${props.direction}`}
            onClick={onClick}
            rippleDisabled={!props.ripple}
        >
            <DirectionalIcon
                direction={
                    props.direction === SideScrollDirection.RIGHT ? directions[1] : directions[0]
                }
            />
        </RippleButton>
    );
};
